import { render, staticRenderFns } from "./seeFirendPopup.vue?vue&type=template&id=e48385c8&scoped=true"
import script from "./seeFirendPopup.vue?vue&type=script&lang=js"
export * from "./seeFirendPopup.vue?vue&type=script&lang=js"
import style0 from "./seeFirendPopup.vue?vue&type=style&index=0&id=e48385c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48385c8",
  null
  
)

export default component.exports